module.exports = __webpack_public_path__ + "static/media/austriaalps.d9e2bce9.jpg";